import { clstx } from '@payaca/utilities/cvaMerge';
import { FunctionComponent, PropsWithChildren, useContext, useId } from 'react';
import { FieldContext, FieldValidationState } from './Context';
import { FieldError } from './FieldError';

type Props = {
  validationState?: FieldValidationState;
  id?: string;
  name?: string;
  className?: string;
};

const FieldLegacy: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
  validationState,
  name,
  className,
  id: customId,
}) => {
  const generatedId = useId();
  const id = customId || generatedId;

  return (
    <FieldContext.Provider
      value={{
        validationState,
        id,
        name,
      }}
    >
      <div className={clstx('typography:prose space-y-2', className)}>
        {children}

        <FieldValidationMessages />
      </div>
    </FieldContext.Provider>
  );
};

const FieldValidationMessages: FunctionComponent = () => {
  const { validationState } = useContext(FieldContext);
  return <ValidationMessages validationState={validationState} />;
};

export const ValidationMessages: FunctionComponent<{
  validationState?: FieldValidationState;
}> = ({ validationState }) => {
  const validationMessages = validationState?.validationMessages;

  if (!validationMessages?.length) return null;

  return <FieldError messages={validationMessages} />;
};

export default FieldLegacy;
